import { useSearchParams } from 'react-router-dom';

/**
 * Keeps the open tab in the URL (?tab=profit) instead of in component state.
 *
 * Two things fall out of this. Browser Back steps to the tab that was open before rather than
 * leaving the page entirely — previously every tab switch was invisible to history, so Back from
 * the fifth tab went straight back to the list. And a tab is now linkable and survives a refresh,
 * which it did not when the state lived in `defaultActiveKey`.
 *
 * setSearchParams pushes by default, which is exactly the history entry we want.
 */
export function useTabHistory(defaultKey: string) {
  const [params, setParams] = useSearchParams();

  const activeKey = params.get('tab') ?? defaultKey;

  const onChange = (key: string) => {
    const next = new URLSearchParams(params);
    next.set('tab', key);
    setParams(next);
  };

  return { activeKey, onChange };
}
